module.exports = __webpack_public_path__ + "static/media/client-area-billing-history.27cd7441.svg";